"use strict";
import { Flex } from "ui/src/components/layout";
export function HiddenFromScreenReaders({ children, style }) {
  return <Flex style={style}>{children}</Flex>;
}
